import { render, staticRenderFns } from "./SiteinfoView.vue?vue&type=template&id=580e3346&scoped=true"
import script from "./SiteinfoView.vue?vue&type=script&lang=ts"
export * from "./SiteinfoView.vue?vue&type=script&lang=ts"
import style0 from "./SiteinfoView.vue?vue&type=style&index=0&id=580e3346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e3346",
  null
  
)

export default component.exports